import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Star } from 'lucide-react';
import { companyInfo, testimonials } from '../data/mock';

const Testimonials = () => {
  const handleWhatsApp = () => {
    window.open(companyInfo.whatsappLink, '_blank');
  };

  return (
    <div className="min-h-screen bg-[#0f1419] pt-20">
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-br from-[#1a1f2e] to-[#0f1419]">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl lg:text-6xl font-bold text-white mb-6">
              Client <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#F59E0B] to-[#FBBF24]">Testimonials</span>
            </h1>
            <p className="text-xl text-gray-300 leading-relaxed">
              Real experiences from real investors who trust us with their financial future
            </p>
          </div>
        </div>
      </section>

      {/* Testimonials Grid */}
      <section className="py-20 bg-[#0f1419]">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
            {testimonials.map((testimonial) => (
              <Card key={testimonial.id} className="bg-[#1a1f2e] border-gray-800 hover:border-[#F59E0B] transition-all hover:shadow-lg hover:shadow-[#F59E0B]/10">
                <CardContent className="p-8">
                  <div className="flex mb-6">
                    {[...Array(testimonial.rating)].map((_, i) => (
                      <Star key={i} className="w-6 h-6 text-[#F59E0B] fill-current" />
                    ))}
                  </div>
                  <p className="text-lg text-gray-300 mb-8 leading-relaxed">
                    "{testimonial.content}"
                  </p>
                  <div className="pt-6 border-t border-gray-800">
                    <div className="font-semibold text-xl text-white mb-1">
                      {testimonial.name}
                    </div>
                    <div className="text-[17px] text-[#F59E0B]">
                      {testimonial.designation}
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-20 bg-gradient-to-br from-[#1a1f2e] to-[#0f1419]">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-4">
              Trusted <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#F59E0B] to-[#FBBF24]">Across India</span>
            </h2>
            <p className="text-xl text-gray-400">
              Join our growing community of satisfied clients
            </p>
          </div>
          <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
            {[
              { value: "12+", label: "Years Experience" },
              { value: "All India", label: "Service Coverage" },
              { value: "5/5", label: "Client Satisfaction" }
            ].map((stat, index) => (
              <div key={index} className="text-center">
                <div className="text-6xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-[#F59E0B] to-[#FBBF24] mb-2">{stat.value}</div>
                <div className="text-lg text-gray-400">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* What Clients Say About Us */}
      <section className="py-20 bg-[#0f1419]">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-12 text-center">
              What Clients <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#F59E0B] to-[#FBBF24]">Value Most</span>
            </h2>
            <div className="grid md:grid-cols-2 gap-8">
              {[
                {
                  title: "Transparency",
                  description: "Clear communication about costs, returns, and risks. No hidden charges or surprises."
                },
                {
                  title: "Personalized Advice",
                  description: "Investment recommendations tailored to individual goals and risk profiles."
                },
                {
                  title: "Long-term Focus",
                  description: "Strategic planning for sustainable wealth creation rather than quick gains."
                },
                {
                  title: "Ongoing Support",
                  description: "Regular portfolio reviews and proactive communication during market changes."
                }
              ].map((item, index) => (
                <Card key={index} className="bg-[#1a1f2e] border-gray-800">
                  <CardContent className="p-8">
                    <h3 className="text-2xl font-semibold mb-3 text-white">
                      {item.title}
                    </h3>
                    <p className="text-[17px] text-gray-300 leading-relaxed">
                      {item.description}
                    </p>
                  </CardContent>
                </Card>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-[#1a1f2e] to-[#0f1419]">
        <div className="container mx-auto px-4 lg:px-8">
          <Card className="bg-gradient-to-r from-[#F59E0B]/10 to-[#FBBF24]/10 border-2 border-[#F59E0B]/30">
            <CardContent className="p-12 text-center">
              <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
                Join Our Happy Clients
              </h2>
              <p className="text-xl text-gray-300 mb-8">
                Start your wealth-building journey with WealthOptimizers today
              </p>
              <Button
                onClick={handleWhatsApp}
                size="lg"
                className="bg-gradient-to-r from-[#F59E0B] to-[#FBBF24] hover:from-[#D97706] hover:to-[#F59E0B] text-black font-semibold px-10 py-6 text-lg"
              >
                Talk to an Expert
              </Button>
              <p className="text-sm text-gray-500 mt-6">
                {companyInfo.disclaimer}
              </p>
            </CardContent>
          </Card>
        </div>
      </section>
    </div>
  );
};

export default Testimonials;